export var CommandMethods;
(function (CommandMethods) {
    CommandMethods["get"] = "get";
    CommandMethods["set"] = "set";
    CommandMethods["merge"] = "merge";
    CommandMethods["delete"] = "delete";
    CommandMethods["subscribe"] = "subscribe";
    CommandMethods["unsubscribe"] = "unsubscribe";
    CommandMethods["observe"] = "observe";
})(CommandMethods || (CommandMethods = {}));
